<template>
  <LoadingScreen id="loading-screen" />
  <Navbar />
  <div class="form-container">
    <div class="header-cont">
      <CircularButton
        class="back-btn"
        icon="long-arrow-alt-left"
        color="#0000"
        @click="goBack()"
      />
      <h2>Account Settings</h2>
    </div>
    <div class="profile-image">
      <img
        :src="formData.profileImage"
        alt="Profile Image"
        style="width: 100%"
      />
      <div class="photo-uploader">
        <label for="profile-image-uploader">
          <fa id="upload-icon" icon="upload" />
        </label>
        <input
          type="file"
          id="profile-image-uploader"
          @change="handleFileUpload"
        />
      </div>
    </div>
    <form @submit.prevent="updateUserInfo">
      <div class="input-field">
        <fa class="icon" icon="at" />
        <label for="email">Email</label>
        <input
          required
          type="email"
          name="email"
          placeholder="Email"
          v-model="formData.email"
          disabled
        />
        <p class="message">Cannot be changed.</p>
      </div>
      <div class="input-field">
        <fa class="icon" icon="user" />
        <label for="fname">First Name</label>
        <input
          required
          type="text"
          name="fname"
          placeholder="First Name"
          v-model="formData.firstName"
        />
      </div>
      <div class="input-field">
        <fa class="icon" icon="user" />
        <label for="lname">Last Name</label>
        <input
          required
          type="text"
          name="lname"
          placeholder="Last Name"
          v-model="formData.lastName"
        />
      </div>
      <Button text="Save Changes" color="#454545" />
    </form>
    <form @submit.prevent="updateUserPwd">
      <div class="input-field">
        <fa class="icon" icon="key" />
        <label for="old_password">Old Password</label>
        <input
          required
          type="password"
          name="old_password"
          placeholder="Old Password"
          v-model="formData.oldPassword"
          id="old-pass"
        />
        <div class="show-pass" @click="showPass('old-pass')" id="show-old-pass">
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <div class="input-field">
        <fa class="icon" icon="key" />
        <label for="new_password">New Password</label>
        <input
          required
          type="password"
          name="new_password"
          placeholder="New Password"
          v-model="formData.password"
          id="new-pass"
        />
        <div class="show-pass" @click="showPass('new-pass')" id="show-new-pass">
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <div class="input-field">
        <fa class="icon" icon="key" />
        <label for="rep_new_password">Repeat New Password</label>
        <input
          required
          type="password"
          name="rep_new_password"
          placeholder="Repeat New Password"
          v-model="formData.repeatPassword"
          id="new-rep-pass"
        />
        <div
          class="show-pass"
          @click="showPass('new-rep-pass')"
          id="show-new-rep-pass"
        >
          <fa class="icon" icon="eye" />
        </div>
      </div>
      <Button text="Change Password" color="#454545" />
    </form>
    <h3>Danger Zone</h3>
    <!-- <div class="input-field"> -->
    <div class="del-account-cont">
      <p>Delete Account</p>
      <Button text="Delete" color="var(--danger)" @click="deleteUserAccount" />
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Button from "@/components/Button.vue";
import CircularButton from "@/components/CircularButton.vue";
import axios from "axios";
import Swal from "sweetalert2";
import LoadingScreen from "@/components/LoadingScreen.vue";

let allowedFileExtensions = ["jpg", "png", "jpeg"];
let jwt;

let headers = {};

function validURL(str) {
  var pattern =
    /(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-/]))?/;
  return pattern.test(str);
}

export default {
  components: { Navbar, Button, CircularButton, LoadingScreen },
  name: "AccountSettings",
  data() {
    return {
      formData: {
        username: "",
        firstName: "",
        lastName: "",
        birthday: "",
        age: "",
        email: "",
        oldPassword: "",
        password: "",
        repeatPassword: "",
        formType: "",
        userToken: "",
        profileImage: "string",
      },
      formDataCopy: {
        username: "",
        firstName: "",
        lastName: "",
        birthday: "",
        age: "",
        email: "",
        oldPassword: "",
        password: "",
        repeatPassword: "",
        formType: "",
        userToken: "",
        profileImage: "string",
      },
    };
  },
  methods: {
    handleFileUpload(event) {
      let self = this;

      // VALIDATE THE FILE
      let splitFilename = event.target.files[0].name.split(".");
      let fileExtension = splitFilename[splitFilename.length - 1];
      // console.log(fileExtension);
      // IF THE FILE IS OF AN UNSUPPORTED TYPE, RETURN WHILE THROWING AN ERROR
      if (!allowedFileExtensions.includes(fileExtension)) {
        Swal.fire(
          "Error",
          "The file you uploaded is not supported. Try uploading a file with a valid extension. <br/><b>Valid extensions:</b> " +
            allowedFileExtensions,
          "error"
        );
        return;
      }

      self.imageFile = event.target.files[0];
      Swal.fire({
        title: "Upload Image?",
        html: "You have uploaded a file: <b>" + self.imageFile.name + "</b>",
        icon: "question",
        showCancelButton: true,
        // cancelButtonColor: "#CC2200",
        confirmButtonText: "Upload",
      }).then((res) => {
        if (res.isConfirmed) {
          this.submitImage();
        }
      });
    },
    submitImage() {
      let formData = new FormData();
      formData.append("file", this.imageFile);
      // console.log(formData);
      let self = this;

      let jwt = localStorage.getItem("jwt");
      if (jwt == null) {
        Swal.fire(
          "An error occured!",
          "Please refresh the page.",
          "error"
        ).then((res) => {
          if (res.isConfirmed) {
            self.$router.push("/");
          }
        });
      }

      axios
        .post(`${process.env.VUE_APP_BACKEND}/users/upload`, formData, {
          headers: headers,
        })
        .then(() => {
          Swal.fire(
            "Uploaded new file",
            "Your new image has been uploaded successfully.",
            "success"
          ).then(() => {
            self.$router.go();
          });
        });
    },
    updateUserInfo() {
      if (
        this.formData.firstName != this.formDataCopy.firstName ||
        this.formData.lastName != this.formDataCopy.lastName
      ) {
        let data = {};
        if (this.formData.firstName != this.formDataCopy.firstName) {
          let firstName = this.formData.firstName;
          data.firstName = firstName;
        }
        if (this.formData.lastName != this.formDataCopy.lastName) {
          let lastName = this.formData.lastName;
          data.lastName = lastName;
        }
        // console.log(data);
        headers["content-type"] = "application/json";
        // // console.log(headers);
        axios
          .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
            headers: headers,
          })
          .then(function () {
            Swal.fire(
              "Success",
              "Your information were updated successfully!",
              "success"
            );
            // console.log(res);
          })
          .catch(function () {
            // console.log(err);
          });
        // console.log("Info Updated.");
      } else {
        // console.log("Same data!");
        Swal.fire(
          "Success",
          "Your information were updated successfully!",
          "success"
        );
      }
    },
    updateUserPwd() {
      if (this.formData.password.length < 6) {
        Swal.fire({
          title: "Your password must be 6 characters or more!",
          text: "We recommend using a strong password, as it can save you from a lot of trouble in the future!",
          icon: "warning",
          confirmButtonText: "Try again",
          confirmButtonColor: "#edc541",
        });
        return;
      }

      // CHECK IF THE PASSWORDS MATCH
      if (this.formData.password != this.formData.repeatPassword) {
        Swal.fire({
          title: "Your passwords do not match!",
          text: 'The fields "New Password" and "Repeat New Password" have different values!',
          icon: "warning",
          confirmButtonText: "Try again",
          confirmButtonColor: "#edc541",
        });
        return;
      }

      if (this.formData.oldPassword == this.formData.password) {
        Swal.fire({
          title: "Your old password is the same with your new!",
          text: "Do you want to continue?",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#4285f4",
          cancelButtonColor: "#ff3018",
          confirmButtonText: "Continue",
        }).then((result) => {
          if (result.isConfirmed) {
            Swal.fire("Changed!", "Your password has been changed.", "success");
          }
        });
        return;
      }

      let oldPass = this.formData.oldPassword;
      let newPass = this.formData.password;

      let data = { oldPassword: oldPass, password: newPass };

      Swal.fire({
        title: "Are you sure you want to change your password?",
        text: "Do you want to continue?",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#4285f4",
        cancelButtonColor: "#ff3018",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.isConfirmed) {
          headers["content-type"] = "application/json";

          axios
            .put(`${process.env.VUE_APP_BACKEND}/users/update`, data, {
              headers: headers,
            })
            .then(function () {
              Swal.fire(
                "Changed!",
                "Your password has been changed. This is the last time we will show you your password, so make sure to save it in a safe place. <br>Your Password: <b>" +
                  data.password +
                  "</b>",
                "success"
              );
              // console.log(res);
            })
            .catch(function () {
              // console.log(err);
              Swal.fire(
                "An error occured!",
                "Your old password is not correct.",
                "error"
              );
            });
        }
      });
      // console.log(data);
    },
    deleteUserAccount() {
      headers["content-type"] = "";
      let self = this;
      Swal.fire({
        title: "Are you sure you want to delete your account?",
        text: "This process is going to delete all your data and is irreversible.",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#4285f4",
        cancelButtonColor: "#ff3018",
        confirmButtonText: "Continue",
      }).then((result) => {
        if (result.isConfirmed) {
          // console.log(data);
          axios
            .delete(`${process.env.VUE_APP_BACKEND}/users/delete`, {
              headers: headers,
            })
            .then(function () {
              // console.log(res);
              Swal.fire({
                title: "Success",
                text: "Your account and all your data were erased successfully!",
                icon: "success",
              }).then(() => {
                localStorage.removeItem("jwt");
                self.$router.push("/");
              });
            })
            .catch(function (err) {
              // console.log(err);
              Swal.fire({
                title: "An error occured!",
                text:
                  "An error occured while deleting your account. <br>Server's response" +
                  err,
                icon: "error",
              });
            });
        }
      });
    },
    goBack() {
      let self = this;
      self.$router.go(-1);
    },
    showPass(id) {
      // console.log("ID: " + id);
      let inputField = document.querySelector("#" + id);
      // console.log(inputField);
      // console.log("Henlo", id);
      if (inputField.getAttribute("type")) {
        inputField.setAttribute("type", "");
      } else {
        inputField.setAttribute("type", "password");
      }
    },
  },
  mounted() {
    let title = "Account Settings - Dating4Pets";
    document.title = title;

    let self = this;
    jwt = localStorage.getItem("jwt");
    if (jwt == null) {
      self.$router.push("/");
    }
    headers = {
      Authorization: "Bearer " + jwt,
      "content-type": "multipart/form-data",
    };

    axios
      .get(`${process.env.VUE_APP_BACKEND}/users/info`, {
        headers: headers,
      })
      .then(function (res) {
        // console.log(res);
        self.formData.firstName = res.data.firstName;
        self.formData.lastName = res.data.lastName;
        self.formData.email = res.data.email;

        self.formDataCopy.firstName = self.formData.firstName;
        self.formDataCopy.lastName = self.formData.lastName;
        self.formDataCopy.email = self.formData.email;

        if (validURL(res.data.profileImage)) {
          self.formData.profileImage = res.data.profileImage;
        } else {
          // GET IMAGE WITH GET REQUEST
          axios
            .get(
              `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`,
              {
                headers: headers,
              }
            )
            .then(function () {
              self.formData.profileImage = `${process.env.VUE_APP_BACKEND}/users/images/${res.data.profileImage}`;
            })
            .catch(() => {
              self.formData.profileImage = "/paw.svg";
            });
        }
        self.formDataCopy.profileImage = self.formData.profileImage;

        setTimeout(() => {
          let loadingScreen = document.querySelector("#loading-screen");
          loadingScreen.classList.add("fade-out");
        }, 1000);
      })
      .catch((err) => {
        // console.log(err.response.data.statusCode);
        if (err.response.data.statusCode == 401) {
          localStorage.removeItem("jwt");
          self.$router.push("/");
        } else {
          Swal.fire("Error", `${err}`, "error");
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  overflow: initial;
  color: var(--dark-clr);
  width: 90%;
  max-width: 50rem;
  height: 80%;
  margin: 1rem;
  padding: 2rem;
  position: relative;
  background: white;
  box-shadow: 0 0.1rem 1rem 0.2rem rgba(126, 126, 126, 0.3);
  border-radius: 1rem;
  margin: auto;
  margin-block-start: 7em;
}

form {
  display: flex;
  flex-direction: column;
  /* height: 100%; */
  justify-content: center;
  align-items: center;

  padding-block: 2em;
  /* padding-inline: 1.5em; */
  gap: var(--gap);
  z-index: 100;
  width: 100%;
  overflow: visible;
}

#form-logo {
  width: 50%;
  aspect-ratio: 1;
}

p {
  color: var(--dark-clr);
}
a {
  text-decoration: none;
}
h2 {
  margin-block: 1em;
}
.form-link {
  color: var(--primary-clr);
  transition: 0.5s ease;
}
.form-link:hover,
.form-link:focus {
  color: var(--dark-clr);
}

.input-field {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  overflow: visible;
  /* width: 60%; */
  /* width: 80%; */
  width: 70%;
  position: relative;
}

.input-field > input {
  height: 2rem;
  min-width: 15em;
  width: 70%;
  max-width: 20em;
  background: white;
  color: var(--dark-clr);
  border-radius: 2rem;
  padding: 0.2rem 1rem;
  margin: 0.2rem;
  /* margin-inline-start: auto; */
  border: none;
  box-shadow: var(--box-shadow);
  font-weight: bold;
  transition: 0.5s ease;
}

.input-field > input::placeholder {
  color: var(--mid-dark-clr);
}

.input-field > input:focus {
  border: none;
  box-shadow: var(--box-shadow-focus);
}

.input-field > .icon {
  /* color: var(--icon-color); */
  color: var(--primary-clr);
  margin: 0 0.5rem;
}

.input-field > input:disabled {
  background: rgb(220, 220, 220);
  box-shadow: none;
}

.message {
  position: absolute;
  right: 0;
  top: -80%;
  /* background: black; */
  /* color: white; */
  height: 2em;
  padding-inline: 0.5em;
  border-radius: 15em;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: var(--light-box-shadow);
  opacity: 0;
  transition: var(--transition);
}
/* .input-field label {
  display: none;
} */

input:disabled:hover + .message {
  opacity: 1;
}

.profile-image {
  background: #0000;
  border-radius: 50%;
  min-width: 10em;
  width: 10%;
  max-width: 30em;
  aspect-ratio: 1;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: var(--transition);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 15%;
  z-index: 1000;
  box-shadow: var(--light-box-shadow);
}

input[type="file"] {
  /* display: none; */
  display: block;
  width: 100%;
  opacity: 0;
  position: absolute;
  height: 100%;
  cursor: pointer;
}

.photo-uploader:hover,
.photo-uploader:focus {
  opacity: 1;
}

.profile-image:hover {
  box-shadow: var(--box-shadow-focus);
}

#upload-icon {
  width: 30%;
  height: 30%;
  color: var(--light-clr);
  /* margin: auto; */
}

.del-account-cont {
  display: flex;
  align-items: center;
  gap: var(--gap);
  overflow: visible;
  margin-block: 2em;
  width: 70%;
}

.back-btn {
  position: absolute;
  left: calc(0% + 2em);
  top: calc(0% + 3em);
  animation-name: playfullCallToAction;
  animation-duration: 5s;
  animation-iteration-count: infinite;
  transition: var(--transition);
}

.header-cont {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.show-pass {
  position: absolute;
  right: calc(0% + 1em);
  cursor: pointer;
}
.show-pass > .icon {
  color: var(--primary-clr);
}
.show-pass:hover > .icon {
  color: var(--mid-dark-clr);
}

@media screen and (max-width: 30rem) {
  .form-container {
    margin: 1rem;
  }
  .back-btn {
    position: relative;
    left: 0;
    top: 0;
  }
}

@media screen and (max-width: 54rem) {
  .input-field {
    justify-content: center;
  }
  .input-field label {
    /* order: -1; */
    /* position: absolute; */
    /* overflow: hidden; */
    display: none;
  }
  .del-account-cont {
    width: 100%;
  }
  .back-btn {
    margin-block-start: 3em;
  }
}
</style>
